import React from "react";

export default function MSAccess_CurDir() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_CurDir</h1>
      <p>This is the MSAccess_CurDir component generated from the SQL JSON.</p>
    </div>
  );
}
